/**
 * Façade for GPT Ad render event.
 *
 * @class SlotRenderEndedEvent
 */

// have to override default slot type by adding string for fallback / tagless
export interface SlotEvent extends Pick<googletag.events.SlotRenderEndedEvent, "isEmpty" | "size"> {
    advertiserId: string | number | null;
    creativeId: string | number | null;
    lineItemId: string | number | null;
    campaignId: string | number | null;
}

interface Props {
    id: string;
    adCode: string;
    requestTime?: DOMHighResTimeStamp;
    event: SlotEvent;
}

export default class SlotRenderEndedEvent {

    _lineItemId: string | number | null;
    _creativeId: string | number | null;
    _isEmpty;
    _size;
    _adId;
    _adCode;
    _adRequestStartTime;
    toJSON;

    /**
     * @constructs SlotRenderEndedEvent
     * @param {google.tags.SlotRenderEndedEvent} event
     * @param {Ad} ad
     */
    constructor({ id, adCode, requestTime, event } : Props) {
        const { advertiserId, campaignId, lineItemId, creativeId, isEmpty, size } = event;

        this._lineItemId = lineItemId;
        this._creativeId = creativeId;
        this._isEmpty = isEmpty;
        this._size = size || [];
        this._adId = id;
        this._adCode = adCode;
        this._adRequestStartTime = requestTime;

        this.toJSON = () => ({ advertiserId, campaignId, lineItemId, creativeId, isEmpty, size });
    }

    getAdId(): string {
        return this._adId;
    }

    getAdCode(): string {
        return this._adCode;
    }

    getLineItemId() {
        return this._lineItemId;
    }

    getCreativeId() {
        return this._creativeId;
    }

    isEmpty(): boolean {
        return this._isEmpty;
    }

    getSize(): string | number[] {
        return this._size;
    }

    // Get GPT request start time
    getRequestTime(): DOMHighResTimeStamp | undefined {
        return this._adRequestStartTime;
    }

}
